import { useJobsStore } from '../../../Store/useJobsStore'
import { useRef } from 'react'

export const useSearchInput = () => {
    const setCurrentSearchTerm = useJobsStore((state) => state.setCurrentSearchTerm)
    const currentSearchTerm = useJobsStore((state) => state.currentSearchTerm)
    const inputRef = useRef(null)

    const handleChange = (event) => {
        if (event.target.value === '') {
            setCurrentSearchTerm('')
        }
        setCurrentSearchTerm(event.target.value)
    }

    return {
        setCurrentSearchTerm,
        currentSearchTerm,
        inputRef,
        handleChange,
    }
}
